/**
 * SaarthAI Brand Logo — inline SVG, no image file needed.
 * variant: "default"  → navy hexagon + white icon  (light backgrounds)
 *          "white"    → white hexagon + navy icon   (rare)
 *          "mono"     → white icon only, no bg fill  (dark backgrounds / sidebars)
 */
export function SaarthLogo({ height = 40, variant = "default" }) {
  const bg      = variant === "default" ? "#1B3A6B" : variant === "white" ? "white" : "none";
  const icon    = variant === "default" ? "white"   : "#1B3A6B";
  const bookBg  = variant === "default" ? "white"   : "#1B3A6B";
  const bookLine= variant === "default" ? "#1B3A6B" : "white";
  const iconOpL = variant === "default" ? 0.9 : 1;
  const iconOpR = variant === "default" ? 0.75 : 0.85;

  return (
    <svg
      height={height}
      viewBox="0 0 44 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", flexShrink: 0 }}
    >
      {/* Hexagon background */}
      <path d="M22 2 L41 12.5 V37.5 L22 48 L3 37.5 V12.5 Z" fill={bg} />

      {/* Mortarboard flat board */}
      <polygon points="22,14 32,19 22,24 12,19" fill={icon} />
      {/* Tassel */}
      <line x1="32" y1="19" x2="32" y2="26" stroke={icon} strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="32" cy="27.5" r="1.5" fill={icon} />

      {/* Open book — left page */}
      <path
        d="M13,27 H21 V37 H13 Q12,37 12,36 V28 Q12,27 13,27 Z"
        fill={bookBg}
        opacity={iconOpL}
      />
      {/* Open book — right page */}
      <path
        d="M31,27 H23 V37 H31 Q32,37 32,36 V28 Q32,27 31,27 Z"
        fill={bookBg}
        opacity={iconOpR}
      />
      {/* Spine */}
      <line x1="22" y1="27" x2="22" y2="37" stroke={bookLine} strokeWidth="1" />
      {/* Left page lines */}
      <line x1="14.5" y1="30"   x2="19.5" y2="30"   stroke={bookLine} strokeWidth="0.8" strokeLinecap="round" />
      <line x1="14.5" y1="32.5" x2="19.5" y2="32.5" stroke={bookLine} strokeWidth="0.8" strokeLinecap="round" />
      <line x1="14.5" y1="35"   x2="17.5" y2="35"   stroke={bookLine} strokeWidth="0.8" strokeLinecap="round" />
      {/* Right page lines */}
      <line x1="24.5" y1="30"   x2="29.5" y2="30"   stroke={bookLine} strokeWidth="0.8" strokeLinecap="round" />
      <line x1="24.5" y1="32.5" x2="29.5" y2="32.5" stroke={bookLine} strokeWidth="0.8" strokeLinecap="round" />
      <line x1="24.5" y1="35"   x2="27.5" y2="35"   stroke={bookLine} strokeWidth="0.8" strokeLinecap="round" />
    </svg>
  );
}

export const TAGLINE = "Study Smart. Score Big.";
